import self from "../img/profile_resized.png";

export let colors = ["#1e40af", "#3b82f6"];

export let singlePage = true;

export const info = {
    firstName: "Filippos",
    lastName: "Kokkinos",
    initials: "fkokkinos",
    position: "AI Research Scientist at Meta",
    selfPortrait: self,
    gradient: `-webkit-linear-gradient(135deg, ${colors})`,
    baseColor: colors[0],
    miniBio: [
        {
            icon: "work",
            text: "AI Research Scientist at Meta"
        },
        {
            icon: "school",
            text: "Ph.D. in Computer Science from UCL"
        },
        {
            icon: "location",
            text: "London, United Kingdom"
        },
        {
            icon: "email",
            text: "filipposkokkinos [at] gmail [dot] com"
        }
    ],
    socials: [
        {
            link: "https://scholar.google.com/citations?user=uuXQjUIAAAAJ&hl=en",
            icon: "fa fa-graduation-cap",
            label: "Google Scholar"
        },
        {
            link: "https://github.com/fkokkinos",
            icon: "fa fa-github",
            label: "GitHub"
        },
        {
            link: "https://www.linkedin.com/in/filippos-kokkinos-03343a138/",
            icon: "fa fa-linkedin",
            label: "LinkedIn"
        },
        {
            link: "https://x.com/filippos_kok",
            icon: "fa fa-twitter",
            label: "X / Twitter"
        }
    ],
    news: [
        {
            date: "04.2026",
            text: "Learning to See Before Seeing: Demystifying LLM Visual Priors from Language Pre-training will be presented at ICLR 2026!",
            link: "https://proceedings.iclr.cc/paper_files/paper/2026/hash/637b275a6e65924719198188fc939632-Abstract-Conference.html",
            tag: "ICLR 2026"
        },
        {
            date: "08.2025",
            text: "Released preprint Towards Physics of Multimodal Pretraining exploring knowledge flow and modality synergy.",
            link: "https://arxiv.org/abs/2608.05000",
            tag: "Preprint"
        },
        {
            date: "06.2025",
            text: "WildCAT3D: Appearance-Aware Multi-View Diffusion in the Wild was accepted to NeurIPS 2025.",
            link: "https://wildcat3d.github.io/",
            tag: "NeurIPS 2025"
        },
        {
            date: "04.2025",
            text: "Gen3DEval: Using vLLMs for Automatic Evaluation of Generated 3D Objects was accepted to CVPR 2025.",
            link: "https://shalini-maiti.github.io/gen3deval.github.io/",
            tag: "CVPR 2025"
        },
        {
            date: "12.2024",
            text: "Meta 3D AssetGen: Text-to-Mesh Generation with High-Quality Geometry and PBR Materials presented at NeurIPS 2024.",
            link: "https://assetgen.github.io/",
            tag: "NeurIPS 2024"
        },
        {
            date: "07.2024",
            text: "Released The Llama 3 Herd of Models and Meta 3D Gen.",
            link: "https://ai.meta.com/blog/meta-llama-3/",
            tag: "Release"
        },
        {
            date: "07.2024",
            text: "VFusion3D: Learning Scalable 3D Generative Models from Video Diffusion Models accepted to ECCV 2024.",
            link: "https://junlinhan.github.io/projects/vfusion3d.html",
            tag: "ECCV 2024"
        },
        {
            date: "05.2024",
            text: "IM-3D: Iterative Multiview Diffusion and Reconstruction for High-Quality 3D Generation accepted to ICML 2024.",
            link: "https://lukemelas.github.io/IM-3D/",
            tag: "ICML 2024"
        }
    ],
    researchThemes: [
        {
            title: "Multimodal Foundation Models & Reasoning",
            description: "Developing scalable vision-language pre-training and reinforcement learning architectures that enable emergent reasoning, multimodal chain-of-thought, and deep perception priors (Llama, Avocado).",
            tags: ["Llama", "Multimodal RL", "Visual Priors", "Reasoning"]
        },
        {
            title: "3D / 4D Generative Modeling & Diffusion",
            description: "Pioneering feed-forward 3D/4D asset generation, text-to-mesh synthesis with PBR materials, and video-to-3D diffusion frameworks (Meta 3D AssetGen, Meta 3D Gen, VFusion3D, Flex3D).",
            tags: ["AssetGen", "3D Gen", "Video Diffusion", "Mesh Generation"]
        },
        {
            title: "Neural Rendering & 3D Reconstruction",
            description: "Developing neural radiance fields (NeRFs), 3D Gaussian Splatting, neural volumetric rendering, and deep structured optimization layers for 2D and 3D inverse problems.",
            tags: ["Neural Rendering", "Gaussian Splatting", "NeRFs", "Inverse Problems"]
        }
    ],
    experience: [
        {
            role: "AI Research Scientist",
            org: "Meta (GenAI / Llama / FAIR)",
            location: "London, UK",
            period: "2022 – Present",
            description: "Leading research across multimodal foundation models, post-training reasoning, and 3D/4D generative models (Meta 3D Gen, AssetGen, Llama 3)."
        },
        {
            role: "Research Intern",
            org: "Microsoft Research",
            location: "Cambridge, UK",
            period: "Jul 2021 – Nov 2021",
            description: "Developed neural radiance fields (NeRFs) for high-fidelity 3D reconstruction and neural rendering of human faces and bodies."
        },
        {
            role: "Research Intern",
            org: "Huawei Noah's Ark Lab",
            location: "London, UK",
            period: "Jul 2019 – May 2021",
            description: "Researched deep spatially adaptive computational graphs and learnable optimization frameworks for computer vision, producing publications at CVPR and ICCV."
        },
        {
            role: "Ph.D. in Computer Science",
            org: "University College London (UCL)",
            location: "London, UK",
            period: "2019 – 2021",
            description: "Advised by Prof. Iasonas Kokkinos. Developed deep structured layers for optimization across 2D and 3D computer vision. 5 first-author papers at CVPR, ECCV, NeurIPS."
        },
        {
            role: "Ph.D. Studies in Computational Data Science",
            org: "Skolkovo Institute of Science and Technology (Skoltech)",
            location: "Moscow, Russia",
            period: "2017 – 2019",
            description: "Research on deep inverse problems and image restoration under Prof. Stamatios Lefkimmiatis; transferred to UCL following advisor's move (IEEE TIP, ECCV)."
        },
        {
            role: "Machine Learning Engineer",
            org: "Behavioral Signals",
            location: "Athens, Greece",
            period: "2016 – 2017",
            description: "Engineered deep learning models to model and predict human intentions and behavioral signals from voice interactions."
        },
        {
            role: "M.Eng. & B.Sc. in ECE",
            org: "National Technical University of Athens (NTUA)",
            location: "Athens, Greece",
            period: "2011 – 2016",
            description: "Graduated with top honors (8.87/10). Published 3 NLP/sentiment papers at EACL and SemEval (1st place competition)."
        }
    ],
    students: [
        { name: "Junlin Han", link: "https://junlinhan.github.io/" },
        { name: "Shalini Maiti", link: "https://www.linkedin.com/in/shalini-maiti-a76a2b86/" },
        { name: "Luke Melas-Kyriazi", link: "https://lukemelas.github.io/" },
        { name: "Yufan Ren", link: "https://yufan-ren.com/" },
        { name: "Konstantinos Tertikas", link: "https://ktertikas.github.io/" },
        { name: "Morris Alper", link: "https://morrisalp.github.io/" },
        { name: "Eric-Tuan Le", link: "https://erictuanle.com/" }
    ],
    mentors: [
        { name: "Prof. Iasonas Kokkinos", link: "https://jkokkin.github.io/" },
        { name: "Prof. Stamatios Lefkimmiatis", link: "https://www.linkedin.com/in/stamatis-lefkimmiatis-37855930/" },
        { name: "Prof. Alexandros Potamianos", link: "https://slp-ntua.github.io/potam/" }
    ],
    services: [
        {
            category: "Conference Reviewer & Program Committee",
            venues: ["CVPR", "ICCV", "ECCV", "NeurIPS", "ICLR", "ICML", "3DV"]
        },
        {
            category: "Journal Reviewer",
            venues: ["IEEE Transactions on Pattern Analysis and Machine Intelligence (TPAMI)", "IEEE Transactions on Image Processing (TIP)", "International Journal of Computer Vision (IJCV)"]
        }
    ]
};
